import { navigate } from "gatsby"
import React, { useState } from "react"
import "../styles/aiAudit.scss"

const API_BASE = 'https://staging.visiomate.com'

const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina",
  "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
  "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana",
  "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon",
  "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros",
  "Congo (Congo-Brazzaville)", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia",
  "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
  "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
  "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
  "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
  "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
  "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua",
  "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
  "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
  "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe",
  "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia",
  "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain",
  "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
  "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",
  "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
  "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
  "Yemen", "Zambia", "Zimbabwe",
]

const CloseIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
)

const MailDoneIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
)

const UserInfoModal = ({ open, onClose }) => {
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [designation, setDesignation] = useState("")
  const [email, setEmail] = useState("")
  const [country, setCountry] = useState("")
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const [alreadyDone, setAlreadyDone] = useState(false)

  const resetForm = () => {
    setFirstName(""); setLastName(""); setCompanyName("")
    setDesignation(""); setEmail(""); setCountry("")
    setSubmitting(false); setError(null); setAlreadyDone(false)
  }

  const handleClose = () => { resetForm(); onClose() }

  const handleSubmit = async e => {
    e.preventDefault()
    setSubmitting(true)
    setError(null)
    try {
      const res = await fetch(`${API_BASE}/api/create-audit-lead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ firstName, lastName, companyName, designation, email, country }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Something went wrong. Please try again.")
        return
      }
      if (data.status === "already_done") {
        setAlreadyDone(true)
        return
      }
      // status === "created" — proceed to audit
      navigate("/ai-audit", {
        state: { userInfo: { firstName, lastName, companyName, designation, email, country } },
      })
    } catch {
      setError("We could not process your request. Please try again or contact us at info@visiomate.com.")
    } finally {
      setSubmitting(false)
    }
  }

  if (!open) return null

  return (
    <div
      className="audit-overlay"
      onClick={e => e.target === e.currentTarget && handleClose()}
    >
      <div className="audit-modal audit-modal--info">

        <div className="audit-modal__header">
          <div className="audit-modal__header-left">
            <span className="audit-modal__eyebrow">AI Readiness Audit</span>
          </div>
          <button className="audit-modal__close" onClick={handleClose} aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div className="audit-modal__body">

          {alreadyDone ? (
            <div className="audit-done">
              <div className="audit-done__icon">
                <MailDoneIcon />
              </div>

              <h2 className="audit-done__heading">Report Already Generated</h2>
              <p className="audit-done__intro">
                An AI Audit Report was previously generated for:
              </p>
              <div className="audit-done__email-chip">{email}</div>

              <div className="audit-done__steps">
                <div className="audit-done__step">
                  <span className="audit-done__step-num">1</span>
                  <div className="audit-done__step-body">
                    <span className="audit-done__step-title">Check your inbox</span>
                    <span className="audit-done__step-desc">
                      Look for an email from <span className="audit-done__step-highlight">visiomateai@gmail.com</span> with subject "Your AI Audit Report — Visiomate".
                    </span>
                  </div>
                </div>
                <div className="audit-done__step">
                  <span className="audit-done__step-num">2</span>
                  <div className="audit-done__step-body">
                    <span className="audit-done__step-title">Check spam / junk folder</span>
                    <span className="audit-done__step-desc">
                      Automated emails sometimes get filtered. Search for "Visiomate" if you can't find it.
                    </span>
                  </div>
                </div>
                <div className="audit-done__step">
                  <span className="audit-done__step-num">3</span>
                  <div className="audit-done__step-body">
                    <span className="audit-done__step-title">Still can't find it?</span>
                    <span className="audit-done__step-desc">
                      Contact us and we'll resend the report or assist you directly.
                    </span>
                  </div>
                </div>
              </div>

              <div className="audit-done__actions">
                <a
                  className="audit-btn audit-btn--primary audit-btn--full"
                  href={`mailto:info@visiomate.com?subject=AI%20Audit%20Report%20Request&body=Hi%2C%20I%20completed%20the%20AI%20Audit%20for%20${encodeURIComponent(email)}%20but%20cannot%20find%20the%20report.%20Please%20resend%20it.`}
                >
                  Email Us at info@visiomate.com
                </a>
                <button className="audit-btn audit-btn--ghost audit-btn--full" onClick={handleClose}>
                  Close
                </button>
              </div>
            </div>
          ) : (
            <>
              <h2 className="audit-flow__heading" style={{ marginBottom: 4 }}>
                Start Your Free AI Audit
              </h2>
              <p className="audit-flow__sub" style={{ marginBottom: 20 }}>
                Tell us a bit about yourself and we'll personalise your report.
              </p>

              <form className="audit-email__form" onSubmit={handleSubmit}>
                <div className="audit-input-row">
                  <input
                    className="audit-input"
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    required
                  />
                  <input
                    className="audit-input"
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    required
                  />
                </div>
                <input
                  className="audit-input"
                  type="text"
                  placeholder="Company Name"
                  value={companyName}
                  onChange={e => setCompanyName(e.target.value)}
                  required
                />
                <input
                  className="audit-input"
                  type="text"
                  placeholder="Designation / Job Title"
                  value={designation}
                  onChange={e => setDesignation(e.target.value)}
                  required
                />
                <input
                  className="audit-input"
                  type="email"
                  placeholder="Work Email Address"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
                <select
                  className="audit-input audit-select"
                  value={country}
                  onChange={e => setCountry(e.target.value)}
                  required
                >
                  <option value="" disabled>Select Country</option>
                  {COUNTRIES.map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>

                {error && <p className="audit-flow__error">{error}</p>}

                <button
                  className="audit-btn audit-btn--primary audit-btn--full"
                  type="submit"
                  disabled={submitting}
                >
                  {submitting
                    ? <><span className="audit-btn-spinner" /> Starting Audit…</>
                    : "Start My Free AI Audit →"}
                </button>
              </form>

              <p className="audit-flow__note" style={{ marginTop: 12 }}>
                Your data is used only to generate and deliver your report.
              </p>
            </>
          )}

        </div>
      </div>
    </div>
  )
}

export default UserInfoModal
